import { Label } from '@/components/ui/label';
import {
  StatusGetInstances,
  StatusGetInstancesLabel,
} from '@/service/one-click-deploy/type';
import {
  CheckCircledIcon,
  CircleIcon,
  CrossCircledIcon,
  ExclamationTriangleIcon,
  ExternalLinkIcon,
} from '@radix-ui/react-icons';
import dayjs from 'dayjs';
import BadgeStatus from '../../components/BadgeStatus';
import { Separator } from '@/components/ui/separator';
import { cn } from '@/lib/utils';
import { Alert, AlertDescription, AlertTitle } from '@/components/ui/alert';
import { Link } from 'react-router-dom';
import { Button } from '@/components/ui/button';
import DeploymentTimeline from './timeline';
import { useGetDedicateInstanceById } from '../hook/useGetDedicateInstanceById';

const OneClickDeployDetailDeployments = () => {
  const { data } = useGetDedicateInstanceById();
  const result = {
    status: data?.status as StatusGetInstances,
    stateDeploy: data?.status as StatusGetInstances,
    startAt: data?.created_at,
    repository: `https://huggingface.co/${data?.model_repo}`,
  };

  return (
    <div className="">
      <p className="text-base font-semibold">Deployments</p>
      <div className="mt-4 flex flex-wrap gap-4">
        <div className="grid w-[130px] items-center gap-1.5">
          <Label className="text-muted-foreground">Started at</Label>
          {result?.startAt
            ? dayjs(result?.startAt).format('DD/MM/YYYY, HH:mm')
            : '-'}
        </div>
        {/* <div className="grid w-[130px] items-center gap-1.5">
          <Label className="text-muted-foreground">End at</Label>
          {result?.startAt
            ? dayjs(result?.endAt).format('DD/MM/YYYY, HH:mm')
            : '-'}
        </div> */}
        <div className="grid w-full max-w-md items-center gap-1.5">
          <Label className="text-muted-foreground">Repository</Label>

          <a
            className="flex cursor-pointer items-center gap-1 text-primary hover:underline"
            target="_blank"
            rel="noopener noreferrer"
            href={result?.repository}
          >
            {result?.repository} <ExternalLinkIcon />
          </a>
        </div>
      </div>
      <Separator className="mt-4" />

      <div className="mt-4">
        <DeploymentTimeline
          status={result.status}
          stateDeploy={result.stateDeploy}
        />
      </div>
      <Separator className="mt-4" />
      {result?.status === StatusGetInstances.Failed && (
        <Alert variant="destructive" className="mt-4">
          <ExclamationTriangleIcon className="h-4 w-4" />
          <AlertTitle>Error</AlertTitle>
          <AlertDescription>
            Something went wrong.
            <br />
            <Link to={''} className="underline">
              Please go to the terminated and new create instance.
            </Link>
          </AlertDescription>
        </Alert>
      )}
    </div>
  );
};

export default OneClickDeployDetailDeployments;
